import styled from 'styled-components';

export const LayoutHeaderContainer = styled.div`
  height: ${({ theme }) => theme.appearance.headerHeight}px;
  z-index: 900;
  position: sticky;
  top: 0;
  width: 100%;

  display: flex;
  align-items: center;

  background-color: ${({ theme }) => theme.colors.white_1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
`;
